import { User } from "../account/account.model";
import { SiteLayout } from "../events/events.model";
import { Confirmation } from "../tickets/tickets.model";

export class TokenResponse {
    SuccessFlag: boolean;
    Token: string;
    trSiteLayout;
    EnableLogging: boolean;
    LoggingProjID: string;
}


export class TokenTest {
    SuccessFlag: boolean;
    Token: string;
}

export class StorageData {
    User: User;
    DefaultSiteLayout: SiteLayout;
    Token: string;
    TokenExpireDate: string;
    Confirmation?: Confirmation;
}



// WEBPACK FOOTER //
// ./src/services/token/token.model.ts